export function ssWrite(key: SSKey, value: any): void {
  const json = JSON.stringify(value);
  sessionStorage.setItem(key, json);
}

export function ssRead(key: SSKey): any {
  const json = sessionStorage.getItem(key);
  if (json) {
    const data = JSON.parse(json);
    return data;
  }
  return null;
}

export function ssRemove(key: SSKey): any {
  sessionStorage.removeItem(key);
}

type SessionStorageModel = {
  /** ページを初回開いたタイミングのsession.provider */
  sso_provider: 'sso' | 'done';
};
type SSKey = keyof SessionStorageModel;
